import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ArchivePageRoutingModule } from './archive-routing.module';

import { SwiperModule } from 'swiper/angular';

import { ArchivePage } from './archive.page';
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { SharedModule } from 'src/app/components/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ArchivePageRoutingModule,
    SwiperModule,
    NgMultiSelectDropDownModule.forRoot(),
    SharedModule
  ],
  declarations: [ArchivePage]
})
export class ArchivePageModule {}
